import { BannerBlueCardMocks } from '../components/banner/mocks/amex/blue.mocks';
import { BannerBusinessGoldCardMocks } from '../components/banner/mocks/amex/business-gold.mocks';
import { BannerBusinessPlatinumCardMocks } from '../components/banner/mocks/amex/business-platinum.mocks';
import { BannerBusinessReserveCardMocks } from '../components/banner/mocks/amex/business-reserve.mocks';
import { BannerGoldCardMocks } from '../components/banner/mocks/amex/gold.mocks';
import { BannerPlatinumCardMocks } from '../components/banner/mocks/amex/platinum.mocks';
import { BannerReserveCardMocks } from '../components/banner/mocks/amex/reserve.mocks';
import { BannerDinersClubCardMocks } from '../components/banner/mocks/diners-club/platinum.mocks';
import { BannerJCBCardMocks } from '../components/banner/mocks/jcb/blue.mocks';
import { BannerJCBGoldCardMocks } from '../components/banner/mocks/jcb/gold.mocks';
import { BannerTakeoffJCBCardMocks } from '../components/banner/mocks/jcb/takeoff.mocks';
import { BannerTrustClubGoldCardMocks } from '../components/banner/mocks/trust-club/gold.mocks';
import { BannerTrustClubPlatiniumCardMocks } from '../components/banner/mocks/trust-club/platinium.mocks';
import { CardCarouselBanner } from '../components/banner/models/banner.interfaces';

const AmexCreditCardsMocks: CardCarouselBanner[] = [
  BannerReserveCardMocks,
  BannerBusinessReserveCardMocks,
  BannerPlatinumCardMocks,
  BannerBusinessPlatinumCardMocks,
  BannerGoldCardMocks,
  BannerBusinessGoldCardMocks,
  BannerBlueCardMocks
];

export const CardSingleMocks: CardCarouselBanner[] = [BannerReserveCardMocks];

export const CardMultiple2Mocks: CardCarouselBanner[] = [
  BannerReserveCardMocks,
  BannerBusinessReserveCardMocks
];

export const CardMultiple3Mocks: CardCarouselBanner[] = [
  BannerReserveCardMocks,
  BannerBusinessReserveCardMocks,
  BannerPlatinumCardMocks
];

export const CardMultiple4Mocks: CardCarouselBanner[] = [
  BannerReserveCardMocks,
  BannerBusinessReserveCardMocks,
  BannerPlatinumCardMocks,
  BannerBusinessPlatinumCardMocks
];

export const CardMultiple5Mocks: CardCarouselBanner[] = [
  BannerReserveCardMocks,
  BannerBusinessReserveCardMocks,
  BannerPlatinumCardMocks,
  BannerBusinessPlatinumCardMocks,
  BannerGoldCardMocks
];

export const CardMultiple6Mocks: CardCarouselBanner[] = [
  BannerReserveCardMocks,
  BannerBusinessReserveCardMocks,
  BannerPlatinumCardMocks,
  BannerBusinessPlatinumCardMocks,
  BannerGoldCardMocks,
  BannerBusinessGoldCardMocks
];

export const CardMultiple7Mocks: CardCarouselBanner[] = AmexCreditCardsMocks;

export const CardMultiple8Mocks: CardCarouselBanner[] = [
  ...AmexCreditCardsMocks,
  BannerDinersClubCardMocks
];

export const CardMultiple9Mocks: CardCarouselBanner[] = [
  ...AmexCreditCardsMocks,
  BannerDinersClubCardMocks,
  BannerJCBCardMocks
];

export const CardMultiple10Mocks: CardCarouselBanner[] = [
  ...AmexCreditCardsMocks,
  BannerDinersClubCardMocks,
  BannerJCBCardMocks,
  BannerJCBGoldCardMocks
];

export const CardMultiple11Mocks: CardCarouselBanner[] = [
  ...AmexCreditCardsMocks,
  BannerDinersClubCardMocks,
  BannerJCBCardMocks,
  BannerJCBGoldCardMocks,
  BannerTakeoffJCBCardMocks
];

export const CardMultiple12Mocks: CardCarouselBanner[] = [
  ...AmexCreditCardsMocks,
  BannerDinersClubCardMocks,
  BannerJCBCardMocks,
  BannerJCBGoldCardMocks,
  BannerTakeoffJCBCardMocks,
  BannerTrustClubGoldCardMocks
];

export const CardMultiple13Mocks: CardCarouselBanner[] = [
  ...AmexCreditCardsMocks,
  BannerDinersClubCardMocks,
  BannerJCBCardMocks,
  BannerJCBGoldCardMocks,
  BannerTakeoffJCBCardMocks,
  BannerTrustClubGoldCardMocks,
  BannerTrustClubPlatiniumCardMocks
];
